import { createSlice, isFulfilled, isPending, isRejected } from '@reduxjs/toolkit'
import { initialSalesState } from 'store/sales/initial.ts'
import {
  createSalesEvent,
  createSalesParameter,
  createSalesUser,
  deleteSalesEvent,
  deleteSalesParameter,
  deleteSalesUser,
  getSalesEvents,
  getSalesParameters,
  getSalesPartners,
  getSalesUsers,
  updateSalesParameter,
  updateSalesUser
} from 'store/sales/thunks'

export const salesSlice = createSlice({
  name: 'sales',
  initialState: initialSalesState,
  reducers: {},
  extraReducers: (builder) => {
    // SPECIFIC THUNK REDUCERS
    builder.addCase(getSalesEvents.fulfilled, (state, { payload }) => {
      state.events = payload.events
    })
    builder.addCase(getSalesPartners.fulfilled, (state, { payload }) => {
      state.partners = payload.partners
    })
    builder.addCase(getSalesParameters.fulfilled, (state, { payload }) => {
      state.parameters = payload.parameters
    })
    builder.addCase(getSalesUsers.fulfilled, (state, { payload }) => {
      state.users = payload.users
    })

    // IS PENDING MATCHER
    builder.addMatcher(
      isPending(
        getSalesEvents,
        getSalesPartners,
        deleteSalesEvent,
        createSalesEvent,
        getSalesParameters,
        deleteSalesParameter,
        createSalesParameter,
        updateSalesParameter,
        deleteSalesUser,
        createSalesUser,
        updateSalesUser
      ),
      (state) => {
        state.loading = true
        state.error = false
      }
    )

    // IS FULFILLED
    builder.addMatcher(
      isFulfilled(
        getSalesEvents,
        getSalesPartners,
        deleteSalesEvent,
        createSalesEvent,
        getSalesParameters,
        deleteSalesParameter,
        createSalesParameter,
        updateSalesParameter,
        deleteSalesUser,
        createSalesUser,
        updateSalesUser
      ),
      (state) => {
        state.loading = false
        state.error = false
      }
    )

    // IS REJECTED
    builder.addMatcher(
      isRejected(
        getSalesEvents,
        getSalesPartners,
        deleteSalesEvent,
        createSalesEvent,
        getSalesParameters,
        deleteSalesParameter,
        createSalesParameter,
        updateSalesParameter,
        deleteSalesUser,
        createSalesUser,
        updateSalesUser
      ),
      (state, err) => {
        state.loading = false
        state.error = err.payload as string
      }
    )
  }
})

export default salesSlice.reducer
